import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMapMarkerAlt,
  faBolt,
  faShieldAlt,
  faHeadset,
  faRupeeSign,
  faMobileAlt,
  faTv,
  faReceipt,
} from "@fortawesome/free-solid-svg-icons";

const About = () => {
  return (
    <section id="about" className="about-section">
      <div className="container">
        <div className="section-header">
          <h2>About Topup Connect</h2>
          <p className="subtitle">
            Your trusted partner for digital payments and recharge services
          </p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <p>
              Founded in Barasat, West Bengal, Topup Connect—operated by{" "}
              <b>CHOTTU TELECOM</b>—has grown from a local service provider into
              a trusted digital platform serving thousands across the region. We
              specialize in delivering fast, secure, and hassle-free mobile
              recharge and bill payment solutions, empowering individuals and
              communities with seamless digital transactions.
            </p>

            <div className="key-features">
              <div className="feature">
                <FontAwesomeIcon icon={faBolt} className="feature-icon" />
                <h4>Instant Processing</h4>
                <p>Most services activated within seconds</p>
              </div>

              <div className="feature">
                <FontAwesomeIcon icon={faShieldAlt} className="feature-icon" />
                <h4>100% Secure</h4>
                <p>Bank-grade security for all transactions</p>
              </div>

              <div className="feature">
                <FontAwesomeIcon icon={faRupeeSign} className="feature-icon" />
                <h4>No Hidden Fees</h4>
                <p>Transparent pricing with no surprises</p>
              </div>

              <div className="feature">
                <FontAwesomeIcon icon={faHeadset} className="feature-icon" />
                <h4>24/7 Support</h4>
                <p>Dedicated customer care always available</p>
              </div>
            </div>
          </div>

          <div className="services-highlight">
            <h3>Our Core Services</h3>
            <ul className="services-list">
              <li>
                <FontAwesomeIcon icon={faMobileAlt} />
                <span>Mobile Recharge (Prepaid/Postpaid)</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faTv} />
                <span>DTH Recharge</span>
              </li>
              <li>
                <FontAwesomeIcon icon={faReceipt} />
                <span>Utility Bill Payments</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="location-card">
          <h3>
            <FontAwesomeIcon icon={faMapMarkerAlt} />
            Our Location
          </h3>
          <address>
            Topup Connect
            <br />
            Barasat - 1, Kathuria, Malikapur
            <br />
            Duttapukur, Barasat
            <br />
            North 24 Parganas, West Bengal - 700126
          </address>
          <p className="timing">
            <strong>Operating Hours:</strong> 8:00 AM - 10:00 PM (Daily)
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
